// extracted by mini-css-extract-plugin
module.exports = {"mainWrapper":"main-module--mainWrapper--ZH-an","mainCol":"main-module--mainCol--lFCNM","articalHeading":"main-module--articalHeading--262mI"};